import { stateInteractionTypeMismatch } from '@azure/msal-browser/dist/error/BrowserAuthErrorCodes'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AdminSettingsHelpModules, AdminSettingsTools } from 'globals/constants'
import { IAppStore } from 'store/app.store'

export interface AdminSettingsToolsTypes {
  openedAdminSettingTool: AdminSettingsTools
  openedAdminSettingsHelpModule: { key: AdminSettingsHelpModules; options: { Title: string; Id?: string } } | null
}
const initialState: AdminSettingsToolsTypes = {
  openedAdminSettingTool: AdminSettingsTools.Users,
  openedAdminSettingsHelpModule: null,
}

export const AdminSettingsToolsSlice = createSlice({
  name: 'AdminSettingsTools',
  initialState,
  reducers: {
    setAdminSettingTool: (state: AdminSettingsToolsTypes, action) => {
      state.openedAdminSettingTool = action.payload
    },
    setOpenedAdminSettingsHelpModule: (
      state,
      action: PayloadAction<{ key: AdminSettingsHelpModules; options: { Title: string; Id?: string } } | null>
    ) => {
      state.openedAdminSettingsHelpModule = action.payload
    },
    closeOpenedAdminSettingsHelpModule: (state) => {
      state.openedAdminSettingsHelpModule = null
    },
  },
})
export const { setAdminSettingTool, setOpenedAdminSettingsHelpModule, closeOpenedAdminSettingsHelpModule } =
  AdminSettingsToolsSlice.actions
export const AdminSettingToolsSelector = (appState: IAppStore): AdminSettingsToolsTypes => appState?.AdminSettingsTool
